/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { lazy, Suspense } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import "./ErrorPage.css";
import { Link } from 'react-router-dom';

const Footer = lazy(() => import("../FooterNewChanges/FooterNewChanges"));

export default function ErrorPage() {
    return (
        <>
        <div className="error-page">
            <Container>
                <Row>
                    <h1>Oh no!</h1>
                    <p>

                        Sorry, you have reached the page which has either been moved or is under update.<br /><br />

                        Please <Link to="/">click here</Link> to go back to the homepage.</p>
                </Row>
            </Container>
            
        </div>
        <div >
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>
      </div>
      </>
    )
}